import * as React from 'react';
import { connect } from 'react-redux';
import * as Components from '../../components/index';
import * as Models from '../../models/index';
import * as ActionCreators from '../../actions/action.creators';

import SetUserName from './views/set.username';
import Questions from './views/questions';
import ChangePassword from './views/change.password';

import './index.scss';

interface StateProps {
	phase: number;
}
interface DispatchProps {
	start(): any;
}
const mapStateToProps = (state: Models.StoreState): StateProps => ({
	phase: state.pwdRecovery.phase,
});
const mapDispatchToProps = (dispatch: any): DispatchProps => ({
	start: () => dispatch(ActionCreators.PwdRecovery.start()),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	class Component extends React.Component<StateProps & DispatchProps, any> {
		componentDidMount() {
			this.props.start();
		}
		renderPhase() {
			switch (this.props.phase) {
				case 1:
					return <SetUserName />;
				case 2:
					return <Questions />;
				case 3:
					return <ChangePassword />;
				default:
					return null;
			}
		}
		render() {
			return (
				<Components.LayoutBlock verticalAlign='center' align='center' className='view password-recovery'>
					<Components.LayoutBlock fill style={{ alignSelf: 'stretch' }}>
						<Components.LayoutBlock inline fill className='header'>
							Password Recovery
						</Components.LayoutBlock>
						<Components.LayoutBlock fill>{this.renderPhase()}</Components.LayoutBlock>
					</Components.LayoutBlock>
				</Components.LayoutBlock>
			);
		}
	}
);
